var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 1200",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bell_svg__st0{fill:#5f5f5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bell_svg__st0",
    d: "M470.6 1087.5c64.7 26.2 134.2 15.1 185.1-22L353 943C364.5 1008.3 409 1063 470.6 1087.5zM1008.8 1080.7c-5.6-53.2-14.8-204.2 9.4-263.9l84.7-209.1c80.2-198-23.5-427.5-230.9-511.5-207.6-83.9-441.6 8.9-521.7 206.9l-85.9 212.1c-21.1 52.2-118.8 145.9-175.4 192.8l-.4.1c0 0-23.7 19.5-17.5 42.9 1.6 16.8 12.8 32.5 30.1 39.5l177.6 71.9 453.1 183.4 0 0 32.9 13.3 177.6 71.9c17.3 7 36.1 3.5 49-7.3h0C1012.2 1111.3 1008.8 1080.7 1008.8 1080.7z"
  })));
};
export default SvgBell;